import { useEffect, useState } from 'react'
import axios from 'axios'
import EditPresentationTime from './editPresentationTime'
import EditJobFairTime from './editJobFairTime'
import EditPresentationNotifyPhones from './editPresentationNotifyPhones'
import EditJobFairNotifyPhones from './editJobFairNotifyPhones'

export default function EventConfig() {
  const [eventConfig, setEventConfig] = useState({})
  const [propsData, setPropsData] = useState({})
  const [isEditPresentationTimeVisible, setIsEditPresentationTimeVisible] = useState(false)
  const [isEditJobFairTimeVisible, setIsEditJobFairTimeVisible] = useState(false)
  const [isEditPresentationNotifyPhonesVisible, setIsEditPresentationNotifyPhonesVisible] = useState(false)
  const [isEditJobFairNotifyPhonesVisible, setIsEditJobFairNotifyPhonesVisible] = useState(false)

  const getEventConfig = () => {
    axios.post('/admin/event/config')
      .then(function (response) {
        if (response.errcode === 0) {
          setEventConfig(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getEventConfig()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const editPresentationTime = () => {
    setIsEditPresentationTimeVisible(true)
    setPropsData({ 
        presentation_start_time: eventConfig.presentation_start_time,
        presentation_end_time: eventConfig.presentation_end_time
    })
  }

  const editJobFairTime = () => {
    setIsEditJobFairTimeVisible(true)
    setPropsData({ 
        job_fair_start_time: eventConfig.job_fair_start_time,
        job_fair_end_time: eventConfig.job_fair_end_time
    })
  }

  const editPresentationNotifyPhones = () => {
    setIsEditPresentationNotifyPhonesVisible(true)
    setPropsData({ presentation_notify_phones: eventConfig.presentation_notify_phones })
  }

  const editJobFairNotifyPhones = () => {
    setIsEditJobFairNotifyPhonesVisible(true)
    setPropsData({ job_fair_notify_phones: eventConfig.job_fair_notify_phones })
  }

  const formatTimeRange = (start, end) => {
    if (!start && !end) return '暂未设置'
    if (start && !end) return `开始时间：${start}`
    if (!start && end) return `结束时间：${end}`
    return `${start} ~ ${end}`
  }

  return (
    <div className="public-page">
      <div className="public-container">
        <div className="public-header">
          <div className="public-title">配置信息</div>
        </div>

        <div className='public-main-style'>
          <div className='public-main-style4'>

            <div className='public-main-style4-items'>
              <div className='public-main-style4-item'>
                <div className='public-main-style4-item-left'>
                  <div className='public-main-style4-item-title'>宣讲会起止时间</div>
                  <div className='public-main-style4-item-description'>
                    {formatTimeRange(
                        eventConfig.presentation_start_time,
                        eventConfig.presentation_end_time
                    )}
                  </div>
                </div>
                <div className='public-main-style4-item-right'>
                  <div className='public-main-style4-item-buttonPrimary' onClick={editPresentationTime}>编辑</div>
                </div>
              </div>
            </div>

            <div className='public-main-style4-items'>
              <div className='public-main-style4-item'>
                <div className='public-main-style4-item-left'>
                  <div className='public-main-style4-item-title'>宣讲会通知短信接收号码</div>
                  <div className='public-main-style4-item-description'>{eventConfig.presentation_notify_phones || '暂未设置'}</div>
                </div>
                <div className='public-main-style4-item-right'>
                  <div className='public-main-style4-item-buttonPrimary' onClick={editPresentationNotifyPhones}>编辑</div>
                </div>
              </div>
            </div>

            <div className='public-main-style4-items'>
              <div className='public-main-style4-item'>
                <div className='public-main-style4-item-left'>
                  <div className='public-main-style4-item-title'>双选会起止时间</div>
                  <div className='public-main-style4-item-description'>
                    {formatTimeRange(
                        eventConfig.job_fair_start_time,
                        eventConfig.job_fair_end_time
                    )}
                  </div>
                </div>
                <div className='public-main-style4-item-right'>
                  <div className='public-main-style4-item-buttonPrimary' onClick={editJobFairTime}>编辑</div>
                </div>
              </div>
            </div>

            <div className='public-main-style4-items'>
              <div className='public-main-style4-item'>
                <div className='public-main-style4-item-left'>
                  <div className='public-main-style4-item-title'>双选会会通知短信接收号码</div>
                  <div className='public-main-style4-item-description'>{eventConfig.job_fair_notify_phones || '暂未设置'}</div>
                </div>
                <div className='public-main-style4-item-right'>
                  <div className='public-main-style4-item-buttonPrimary' onClick={editJobFairNotifyPhones}>编辑</div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      {isEditPresentationTimeVisible && <EditPresentationTime
        data={propsData}
        getEventConfig={getEventConfig}
        isOpen={isEditPresentationTimeVisible}
        isCancel={() => { setIsEditPresentationTimeVisible(false) }}
      />}
      {isEditJobFairTimeVisible && <EditJobFairTime
        data={propsData}
        getEventConfig={getEventConfig}
        isOpen={isEditJobFairTimeVisible}
        isCancel={() => { setIsEditJobFairTimeVisible(false) }}
      />}
      {isEditPresentationNotifyPhonesVisible && <EditPresentationNotifyPhones
        data={propsData}
        getEventConfig={getEventConfig}
        isOpen={isEditPresentationNotifyPhonesVisible}
        isCancel={() => { setIsEditPresentationNotifyPhonesVisible(false) }}
      />}
      {isEditJobFairNotifyPhonesVisible && <EditJobFairNotifyPhones
        data={propsData}
        getEventConfig={getEventConfig}
        isOpen={isEditJobFairNotifyPhonesVisible}
        isCancel={() => { setIsEditJobFairNotifyPhonesVisible(false) }}
      />}
    </div>
  )
}
